import { supabase } from "@/services/supabase/createClient";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import keyBy from "lodash.keyby";
import * as Sentry from "@sentry/react";

export const getTeamMembers = async (teamId?: string) => {
  if (!teamId) {
    const { data: sessionData } = await supabase.auth.getSession();
    return {
      [sessionData?.session?.user?.id || ""]: {
        id: sessionData?.session?.user?.id,
        picture: sessionData?.session?.user?.user_metadata?.picture,
        name: sessionData?.session?.user?.user_metadata?.name,
        email: sessionData?.session?.user?.email,
        role: "team_owner",
      },
    };
  }

  const { data, error } = await supabase.rpc("get_team_members", { team_uuid: teamId });

  if (error) {
    Sentry.captureException(error);
    throw new Error(error.message);
  }

  if (!data?.length) return;

  return keyBy(data, "id");
};

export const useTeamMembers = (teamId?: string) => {
  return useQuery({
    queryKey: ["team_members", teamId],
    queryFn: () => getTeamMembers(teamId),
  });
};

export const useTeamMemberSubscription = () => {
  const queryClient = useQueryClient();
  return useQuery({
    queryKey: ["teams_member_subscription"],
    queryFn: () => {
      const channels = supabase
        .channel("team_members_all")
        .on("postgres_changes", { event: "*", schema: "public", table: "team_members" }, () => {
          queryClient.invalidateQueries({
            predicate: (query) => query.queryKey?.[0] === "team_members",
          });
        })
        .subscribe();
      return () => {
        channels.unsubscribe();
      };
    },
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
};
